import { render, staticRenderFns } from "./meals-top-panel.vue?vue&type=template&id=06cc5548&"
import script from "./meals-top-panel.vue?vue&type=script&lang=js&"
export * from "./meals-top-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports